import React from 'react';
import {SOCIALS, TOP_SECTION} from '../../Module/General';
import MytypedComponent from '../typing-effect/typing.js';
import {LinearProgressBar} from '../ProgressBar';
import './top-division-c.css';
import {HashLink as Link} from 'react-router-hash-link';

function Btn(props) {
  return (
    <button className={props.class}>
      <i className={props.ico}></i>
      {props.type}
      <div className="overlay">
        <div className="overlay-text">{props.overlay}</div>
      </div>
    </button>
  );
}
function padTo2Digits(num) {
  return String(num).padStart(2, '0');
}
function About() {
  const start = new Date(2023, 11, 16, 9, 0, 0, 0).getTime();
  const end = new Date(2023, 11, 16, 15, 30, 0, 0).getTime();
  const [current, setCurrent] = React.useState(Date.now());

  React.useEffect(() => {
    let myInterval = setInterval(() => {
      let now = Date.now();
      if(now > end) {
        now = end;
      }
      setCurrent(now);
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, []);

  const progress = ((current - start) * 100) / (end - start);
  return (
    <div className="AboutMe">
      <h2>{TOP_SECTION.TITLE}</h2>
      <MytypedComponent />
      <LinearProgressBar
        label={`${padTo2Digits(new Date(current).getHours())}:${padTo2Digits(
          new Date(current).getMinutes()
        )}`}
        percent={progress}
        animateTiming={1000}
      />
    </div>
  );
}

function Myinfo() {
  return (
    <div className="Myinfo">
      <About />
      <p> {TOP_SECTION.SHORT_DESCRIPTION}</p>

      <div className="buttom-group">
        <a href={TOP_SECTION.JUDGES_FORM_LINK}>
          <Link to={`/get-started`}>
            <Btn
              class="register"
              type="Get started"
              overlay="Start your project"
            />{' '}
          </Link>
        </a>
        <a href={TOP_SECTION.PARTICIPANT_LINK}>
          <Btn
            class="sponsor_btn"
            type="View Registered Hackers"
            overlay="And update your details!"
          />
        </a>
      </div>
    </div>
  );
}

export {Btn, Myinfo};
